export default "__VITE_ASSET__WH8lyDGd__"